import React, { useEffect, useRef, useState } from 'react';
import redtick from './redtick.png';
import wrong from './wrong.png';
import DescriptionIcon from '@mui/icons-material/Description';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; 
import { FiArrowLeft } from 'react-icons/fi';
import api from '../../api/api';
import ToastMessage from '../../utils/muitoast';
import { Backdrop, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import SignatureModal from '../Signaturemodal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faUpload } from '@fortawesome/free-solid-svg-icons';
import { useSearchParams } from "react-router-dom";
import { set } from 'date-fns';
import moment from 'moment';
const MultiStepForm = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [severity, setSeverity] = useState('success');
  const [open, setOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [showEmpSuggestions, setShowEmpSuggestions] = useState(false);
  const [employeeId, setEmployeeId] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [employeeSuggestions, setEmployeeSuggestions] = useState([]);
  const [selectedempobj,setselectedempobj]=useState({})
  const [suggestions, setSuggestions] = useState([]);
    const [jobCode, setJobCode] = useState('');
    const [selectedJobName, setSelectedJobName] = useState('');
    const [companyTabs, setCompanyTabs] = useState([]); // Replaces 'Tabs'
    const [selectedCompanyId, setSelectedCompanyId] = useState(null); // To store selected company ID
    const jobInputRef = useRef(null);
     const [signaturemodal,setSignatureModal]=useState(false)
    const empInputRef = useRef(null);
    const [hoveredJobIndex, setHoveredJobIndex] = useState(null);
const [hoveredEmpIndex, setHoveredEmpIndex] = useState(null);
  const [commentImages, setCommentImages] = useState([]);
  const [editedCommentedImages, setEditedCommentImages] = useState([]);
const [driverSignature,setDriverSignature]=useState('')
const [serverdriverSignature,setServerDriverSignature]=useState('')
const [pmolist,setpmolist]=useState([])
    const [searchParams] = useSearchParams();
       const mode = searchParams.get("mode"); // null if not sent
const id = searchParams.get("id");     // null if not sent
  // ── Week-anchored Driver Log Entries (mirrors mobile app design) ──────────
  // The form always shows 7 cards (Mon–Sun) for the selected ISO week. Each
  // card is locked to its weekday's date. A `dayOff` flag hides the data
  // fields and exempts that day from required-field validation.
  const todayWeekStartStr = moment().startOf('isoWeek').format('YYYY-MM-DD');
  const generateWeekEntries = (weekStartStr) => {
    const start = moment(weekStartStr, 'YYYY-MM-DD');
    const out = [];
    for (let i = 0; i < 7; i++) {
      const d = start.clone().add(i, 'days');
      out.push({
        dateoflog: d.format('YYYY-MM-DD'),
        dayLabel: d.format('dddd'),
        dayOff: false,
        start: '',
        end: '',
        job: '',
        fillUp: false,
        location: '',
        gallons: '',
        amount: '',
        milege: '',
      });
    }
    return out;
  };
  const [selectedWeekStart, setSelectedWeekStart] = useState(todayWeekStartStr);
  const [logEntries, setLogEntries] = useState(() =>
    generateWeekEntries(todayWeekStartStr),
  );

  const isAtCurrentWeek =
    moment(selectedWeekStart, 'YYYY-MM-DD').isSameOrAfter(
      moment(todayWeekStartStr, 'YYYY-MM-DD'),
    );
  const navigateToWeek = (newWeekStartStr) => {
    if (
      moment(newWeekStartStr, 'YYYY-MM-DD').isAfter(
        moment(todayWeekStartStr, 'YYYY-MM-DD'),
      )
    ) {
      return;
    }
    const fresh = generateWeekEntries(newWeekStartStr);
    setSelectedWeekStart(newWeekStartStr);
    setLogEntries(fresh);
    setFormData((prev) => ({ ...prev, step2Data: fresh }));
    setAmountWarnings({});
    setLogEntryErrors({});
  };
  const goToPrevWeek = () => {
    const newStart = moment(selectedWeekStart, 'YYYY-MM-DD')
      .subtract(1, 'week')
      .format('YYYY-MM-DD');
    navigateToWeek(newStart);
  };
  const goToNextWeek = () => {
    if (isAtCurrentWeek) return;
    const newStart = moment(selectedWeekStart, 'YYYY-MM-DD')
      .add(1, 'week')
      .format('YYYY-MM-DD');
    navigateToWeek(newStart);
  };
  const selectedWeekLabel = (() => {
    const start = moment(selectedWeekStart, 'YYYY-MM-DD');
    const end = start.clone().endOf('isoWeek');
    if (start.year() === end.year()) {
      return `${start.format('MMM D')} – ${end.format('MMM D, YYYY')}`;
    }
    return `${start.format('MMM D, YYYY')} – ${end.format('MMM D, YYYY')}`;
  })();

  // Per-card JOB # autocomplete state — only one dropdown is open at a time.
  const [entryJobSuggestions, setEntryJobSuggestions] = useState([]);
  const [openJobEntryIndex, setOpenJobEntryIndex] = useState(null);
  const entryJobRef = useRef(null);
  const fetchEntryJobSuggestions = async (query) => {
    try {
      if (!query) {
        setEntryJobSuggestions([]);
        return;
      }
      if (/^0{1,4}$/.test(query)) {
        setEntryJobSuggestions([{ job_num: '0000', job_name: 'Overhead' }]);
        return;
      }
      const response = await api.get(`/v1/timesheets/get-jobs`, {
        params: { company_id: selectedCompanyId, job_num: query },
      });
      if (response.status === 200) {
        setEntryJobSuggestions(response.data || []);
      } else {
        setEntryJobSuggestions([]);
      }
    } catch (error) {
      console.error('Error fetching entry job suggestions:', error);
    }
  };
  // Per-row inline warning for the amount/gallons sanity check.
  // Shape: { [rowIndex]: "message" } — present means the row's amount/gallons
  // pair is suspicious; field borders go red and the message renders below.
  const [amountWarnings, setAmountWarnings] = useState({});
  // Per-row, per-field blocking errors surfaced inline below each input
  // instead of a toast. Shape: { [rowIndex]: { [fieldKey]: "message" } }.
  // Populated by the Step-2 validation pass; cleared as the user edits.
  const [logEntryErrors, setLogEntryErrors] = useState({});
  const clearLogEntryError = (index, field) => {
    setLogEntryErrors((prev) => {
      const row = prev[index];
      if (!row || !row[field]) return prev;
      const nextRow = { ...row };
      delete nextRow[field];
      const next = { ...prev };
      if (Object.keys(nextRow).length === 0) delete next[index];
      else next[index] = nextRow;
      return next;
    });
  };
  // Confirmation modal shown when the user clicks Submit on the final step
  // with one or more days marked "Day off". `dayOffNames` is a human-readable
  // list (e.g. ["Friday", "Saturday"]) used to render the message.
  const [dayOffConfirmModal, setDayOffConfirmModal] = useState({
    open: false,
    dayOffNames: [],
  });
  const { t, i18n } = useTranslation(['weeklydriver']);
  const [selectedLanguage, setSelectedLanguage] = useState('en');
  
  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setSelectedLanguage(lang);
  };

  const [formData, setFormData] = useState({
    companyId: null,
    emp_Id:null,
    pm_id:'',
    pm_name:'',
    jobNumber: '',
    empname:'',
    drivername: '',
    fuelallocation:'',
    unitnumber: '',
    date: '',
    method:'',
    step2Data: logEntries,
    // Step 3: Vehicle Check (Part 1)
    ACCIDENTFORM: '',
    BATTERY: '',
    BELTS: '',
    BRAKEFLUID: '',
    ENGINEOIL: '',
    FIREEXTINGUISHER: '',
    FIRSTAIDKIT: '',
    HEADLAMPSHIBEAMS: '',
    HEATERHOSES: '',
    HITCHRECEIVERANDPINS: '',
    HORN: '',
    INSURANCECARD: '',
    JACKTIREIRON: '',
    LIGHTSParkingBRAKE: '',
    MIRRORS: '',
    PARKINGBRAKE: '',
    RADIATORFLUID: '',
    RADIATORHOSES: '',
    SEATBELTS: '',
    SPARETIRE: '',
    STEERINGFLUID: '',
    TIREPSI: '',
    TRANSMISSIONOIL: '',
    TURNSIGNALS: '',
    WASHERFLUID: '',
    WINDSHIELDWIPERS: '',
    // Step 4: Comments and Additional Fields
    comments: '',
    checkedby: '',
    sign: '',
  });
  
  const groupedItems = [
    ["ACCIDENT FORM", "BATTERY"],
    ["BELTS", "BRAKE FLUID"],
    ["ENGINE OIL", "FIRE EXTINGUISHER (10lb)"],
    ["FIRST AID KIT", "HEADLAMPS & HI-BEAMS"],
    ["HEATER HOSES", "HITCH, RECEIVER, AND PINS"],
    ["HORN", "INSURANCE CARD"],
    ["JACK & TIRE IRON", ""],
  ];

  const step4groupedItems = [
    ["LIGHTS (Parking & BRAKE)", "MIRRORS"],
    ["PARKING BRAKE", "RADIATOR FLUID"],
    ["RADIATOR HOSES", "SEATBELTS"],
    ["SPARE TIRE", "STEERING FLUID"],
    ["TIRE PSI", "TRANSMISSION OIL"],
    ["TURN SIGNALS", "WASHER FLUID"],
    ["WINDSHIELD WIPERS"],
  ];

  const handleRadioChange = (item, value) => {
    setFormData(prev => ({
      ...prev,
      [item]: value,
    }));
  };

  // Plausible US fuel-price band ($/gallon). If amount/gallons falls outside
  // this we surface a soft alert so the driver can correct it — typical
  // mistake is putting the odometer reading in the "Total Amount" cell.
  const FUEL_PRICE_MIN = 1.5;
  const FUEL_PRICE_MAX = 10;

  const validateAmountVsGallons = (entry) => {
    const gal = parseFloat(entry.gallons);
    const amt = parseFloat(entry.amount);
    if (!isFinite(gal) || gal <= 0) return null;
    if (!isFinite(amt) || amt <= 0) return null;
    const pricePerGal = amt / gal;
    if (pricePerGal < FUEL_PRICE_MIN || pricePerGal > FUEL_PRICE_MAX) {
      return 'Please double check the amount';
    }
    return null;
  };

  const handleEntryChange = (index, field, value) => {
    const updatedEntries = [...logEntries];
    updatedEntries[index][field] = value;
    // Any edit clears the inline error on that field. Toggling fillUp/dayOff
    // off also clears errors on the hidden fields (handled in the blocks
    // below that blank them out).
    clearLogEntryError(index, field);
    // When FILL-UP is unchecked, blank out the fields so we don't ship stale
    // values to the backend or fail validation on hidden inputs.
    if (field === 'fillUp' && value === false) {
      updatedEntries[index].location = '';
      updatedEntries[index].gallons = '';
      updatedEntries[index].amount = '';
      updatedEntries[index].milege = '';
      setAmountWarnings(prev => {
        const next = { ...prev };
        delete next[index];
        return next;
      });
      ['location', 'gallons', 'amount', 'milege'].forEach((f) =>
        clearLogEntryError(index, f),
      );
    }
    // Toggling DAY OFF on hides the whole data section — blank out the inputs
    // so the previously typed values don't get submitted or block validation.
    if (field === 'dayOff' && value === true) {
      updatedEntries[index].start = '';
      updatedEntries[index].end = '';
      updatedEntries[index].job = '';
      updatedEntries[index].fillUp = false;
      updatedEntries[index].location = '';
      updatedEntries[index].gallons = '';
      updatedEntries[index].amount = '';
      updatedEntries[index].milege = '';
      setAmountWarnings(prev => {
        const next = { ...prev };
        delete next[index];
        return next;
      });
      // Day-off rows are exempt from required-field validation, so drop
      // anything we previously flagged on this row.
      setLogEntryErrors((prev) => {
        if (!prev[index]) return prev;
        const next = { ...prev };
        delete next[index];
        return next;
      });
    }
    setLogEntries(updatedEntries);
    setFormData(prev => ({
      ...prev,
      step2Data: updatedEntries,
    }));
    // Clear any stale amount/gallons warning the moment the user edits — they'll
    // be revalidated on blur.
    if ((field === 'amount' || field === 'gallons') && amountWarnings[index]) {
      setAmountWarnings(prev => {
        const next = { ...prev };
        delete next[index];
        return next;
      });
    }
  };

  // Run validations only when the user leaves a field — never on each
  // keystroke — so they can freely type "150" without being stopped at "1".
  const handleEntryBlur = (index, field) => {
    const entry = logEntries[index];
    if (!entry) return;
    const num = parseFloat(entry[field]);

    if (field === "start" && index > 0 && isFinite(num)) {
      const prevEnd = parseFloat(logEntries[index - 1]?.end);
      if (isFinite(prevEnd) && num < prevEnd) {
        showError(
          `Mileage Start must be at least ${prevEnd} (the previous entry's Mileage End).`,
        );
      }
    }
    if (field === "end" && isFinite(num)) {
      const sameStart = parseFloat(entry.start);
      if (isFinite(sameStart) && num < sameStart) {
        showError(
          `Mileage End must be greater than or equal to Mileage Start (${sameStart}).`,
        );
      }
      const nextStart = parseFloat(logEntries[index + 1]?.start);
      if (isFinite(nextStart) && nextStart < num) {
        showError(
          `Heads up: the next entry's Mileage Start (${nextStart}) is now below this row's Mileage End (${num}). Update the next row.`,
        );
      }
    }
    if (field === "amount" || field === "gallons") {
      const warn = validateAmountVsGallons(entry);
      setAmountWarnings(prev => {
        const next = { ...prev };
        if (warn) next[index] = warn;
        else delete next[index];
        return next;
      });
    }
  };
const HandleSignature=(x)=>{
  setDriverSignature(x)
}
  const handleAddEntry = () => {
    const newEntry = {
      dateoflog: '',
      start: '',
      end: '',
      job: '',
      fillUp: false,
      location: '',
      gallons: '',
      amount: '',
      milege: '',
    };
    setLogEntries((prev) => [...prev, newEntry]);
    setFormData((prev) => ({
      ...prev,
      step2Data: [...prev.step2Data, newEntry],
    }));
  };

  const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  const generateJsonData = (formData) => {
    const json = [];
  
    // // Step 1: Basic Info
    // if (formData.drivername) {
    //   json.push({
    //     question: "Driver Name",
    //     answer: formData.drivername
    //   });
    // }
    if (formData.unitnumber) {
      json.push({
        question: "Driver Information - Unit Number",
        answer: formData.unitnumber
      });
    }
    if(formData?.fuelallocation){
       json.push({
        question: "Driver Information - Fuel Allocation",
        answer: formData.fuelallocation
      });
    }
  if (formData.commentImagesUploaded && formData.commentImagesUploaded.length > 0) {
  json.push({
    question: "Comments - Uploaded Images",
    answer: formData.commentImagesUploaded.map(
      (img) => ({
        file_name: img.file_name,
        file_path: img.file_path
      })
    )
  });
}


    // if (formData.date) {
    //   json.push({
    //     question: "Date",
    //     answer: formData.date
    //   });
    // }
  
    // Step 2: Log Entries
    if (Array.isArray(formData.step2Data)) {
      json.push({
        question: "Driver Log Entries",
        answer: formData.step2Data.map(entry => ({
          date: entry.dateoflog,
          dayLabel: entry.dayLabel || '',
          dayOff: !!entry.dayOff,
          mileage: entry.milege,
          Start:entry.start,
          End:entry.end,
          location: entry.location,
          gallons: entry.gallons,
          amount:entry.amount,
          Job :entry.job,
          fillUp: !!entry.fillUp
        }))
      });
    }
    
  
   // Step 3 - Part 1 Labels (match UI exactly)
const part1Labels = [
  "ACCIDENT FORM", "BATTERY", "BELTS", "BRAKE FLUID", "ENGINE OIL",
  "FIRE EXTINGUISHER (10lb)", "FIRST AID KIT", "HEADLAMPS & HI-BEAMS",
  "HEATER HOSES", "HITCH, RECEIVER, AND PINS", "HORN", "INSURANCE CARD", "JACK & TIRE IRON"
];

part1Labels.forEach(label => {
  if (formData[label]) {
    json.push({
      question: ` Vehicle Safety Check (Part-1) - ${label}`,
      answer: formData[label]
    });
  }
});

// Step 4 - Part 2 Labels (match UI exactly)
const part2Labels = [
  "LIGHTS (Parking & BRAKE)", "MIRRORS", "PARKING BRAKE", "RADIATOR FLUID",
  "RADIATOR HOSES", "SEATBELTS", "SPARE TIRE", "STEERING FLUID",
  "TIRE PSI", "TRANSMISSION OIL", "TURN SIGNALS", "WASHER FLUID", "WINDSHIELD WIPERS"
];

part2Labels.forEach(label => {
  if (formData[label]) {
    json.push({
      question: ` Vehicle Safety Check (Part-2) - ${label}`,
      answer: formData[label]
    });
  }
});

  
    // Step 4: Comments and Review
    if (formData.comments) {
      json.push({
        question: "Comments",
        answer: formData.comments
      });
    }
    if (formData.checkedby) {
      json.push({
        question: "Checked By",
        answer: formData.checkedby
      });
    }
    if (formData?.signatures.length) {
      json.push({
        question: "Signature",
        answer: formData?.signatures
      });
    }
  
    return json;
  };
  
  

  const handleSubmit = async () => {
    


    try {
      setLoader(true);

   setLoader(true);

   
//   const formDataa = new FormData();
// const allUploads = [];

// // Append driver signature
// if (driverSignature instanceof File) {
//   formDataa.append('files', driverSignature);
//   allUploads.push({ type: 'signature' });
// }

// // Append all comment images (if any)
// if (Array.isArray(formData.commentImages) && formData.commentImages.length > 0) {
//   formData.commentImages.forEach((file) => {
//     if (file instanceof File) {
//       formDataa.append('files', file);
//       allUploads.push({ type: 'commentImg' });
//     } else {
//       console.warn("Invalid comment image skipped:", file);
//     }
//   });
// }

// let uploadedFiles = [];
// let signatureResp = [];
// let commentImgsResp = [];

// // Upload all files in one API call
// try {
//   const imgresponse = await api.post('/v1/forms/upload-files', formDataa, {
//     headers: { 'Content-Type': 'multipart/form-data' },
//   });

//   uploadedFiles = Array.isArray(imgresponse?.files) ? imgresponse.files : [];

//   // Map each uploaded file back to its type (using order)
//   let index = 0;
//   uploadedFiles.forEach((uploaded) => {
//     const meta = allUploads[index];
//     index++;

//     if (!meta) return; // Safety check

//     if (meta.type === 'signature') {
//       signatureResp.push(uploaded);
//     } else if (meta.type === 'commentImg') {
//       commentImgsResp.push(uploaded);
//     }
//   });
// } catch (error) {
//   console.error("File upload failed:", error);
//   uploadedFiles = [];
// }
const formDataa = new FormData();
const allUploads = [];

// Append driver signature
if (driverSignature instanceof File) {
  formDataa.append("files", driverSignature);
  allUploads.push({ type: "signature" });
}

// Append comment images
if (Array.isArray(formData.commentImages)) {
  formData.commentImages.forEach((file) => {
    if (file instanceof File) {
      formDataa.append("files", file);
      allUploads.push({ type: "commentImg" });
    }
  });
}

let uploadedFiles = [];
let signatureResp = [];
let commentImgsResp = [];

// ❗ If no files, skip API call completely
if (allUploads.length === 0) {
  console.warn("No files to upload. Skipping API call.");

}

try {
  const imgresponse = await api.post("/v1/forms/upload-files", formDataa, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  uploadedFiles = Array.isArray(imgresponse?.files) ? imgresponse.files : [];

  // 🛡 Always map BACK to type in perfect order
  uploadedFiles.forEach((uploadedFile, i) => {
    const meta = allUploads[i];
    if (!meta) return;

    if (meta.type === "signature") {
      signatureResp.push(uploadedFile);
    } else if (meta.type === "commentImg") {
      commentImgsResp.push(uploadedFile);
    }
  });
} catch (error) {
  console.error("File upload failed:", error);
  uploadedFiles = [];
}


const mergedCommentImages = [
  ...(formData.commentImagesUploaded || []), // OLD server images
  ...(commentImgsResp || [])                 // NEW uploaded images
];

// ✅ Generate final JSON payload
const jsonData = generateJsonData({
  ...formData,
  ...(signatureResp.length > 0 && { signatures: signatureResp }),
  ...(commentImgsResp.length > 0 && { commentImagesUploaded: mergedCommentImages}),
});
let obj={
        emp_id: formData.emp_Id,
        emp_name: formData.empname,
        //   pm_id: formData.pm_id,
        // pm_name: formData.pm_name,
        companyid: formData.companyId,
        form_type: "WDS",
        job_id: formData.jobNumber,
        job_description: `${selectedJobName}-(${jobCode})`,
        observer_name: formData.empname,
        filled_date: formData.date,
        json_data: jsonData,
        documents: "",
        method:formData.method
      }
      let response;

   if(mode==="edit"&&id){
        obj.row_id=id
  response = await api.post('/v1/forms/create-update-form',obj );
      }else{
  
    
        response = await api.post('/v1/forms/create-form', obj);
      }
      if (response.status === 200) {
        setOpen(true);
        setSeverity("success");
        setAlertMessage('Submitted Successfully');
        setTimeout(() => {
          setOpen(false);
          navigate(-1);
        }, 2000);
      }
    } catch (error) {
      setSeverity("error");
      setAlertMessage('Something went wrong');
      setOpen(true);
      console.log("Submission error:", error);
    } finally {
      setLoader(false);
    }
  };
  


  const nextStep = (force = false) => {
    switch (currentStep) {
      case 1:
        if (!formData.method) return showError("Please select Method");
        if (!formData.companyId) return showError("Please select Company ID");       
  // if (!formData.pm_id) return showError("Please select project manager");     
      if (!formData.jobNumber) return showError("Please enter Job ID");
        if (!formData.empname) return showError("Please enter Driver Name");
         if (!formData.emp_Id) return showError("Please select driver name from suggestions only");
        //  if (!formData.unitnumber) return showError("Please enter unit Name");
        if (!formData.date) return showError("Please select a Date");
        break;
  
      case 2: {
        if (!formData.step2Data || formData.step2Data.length === 0) {
          return showError("Please add at least one Log Entry");
        }

        // Fill-up fields are only required when the row's FILL-UP box is checked.
        const baseRequiredLogFields = [
          { key: "start", label: "Mileage Start" },
          { key: "end",   label: "Mileage End"   },
          { key: "job",   label: "Job #"          },
        ];
        const fillUpRequiredFields = [
          { key: "location", label: "Repair / Fill-Up Location"     },
          { key: "gallons",  label: "Gallons Fuel"                  },
          { key: "amount",   label: "Total Amount"                  },
          { key: "milege",   label: "Mileage @ Repair / Fill-Up"    },
        ];

        // Reject placeholder fillers like "n/a", "na", "-", "none", etc.
        const isFillerValue = (v) => {
          const s = String(v ?? "").trim().toLowerCase();
          if (!s) return true;
          return ["n/a", "na", "n.a", "n.a.", "none", "-", "--", "n\\a"].includes(s);
        };

        // Collect ALL per-row, per-field errors in one pass instead of
        // surfacing a toast on the first failure. The user sees every
        // problem highlighted at once and can fix them in any order.
        const errs = {};
        const addErr = (i, field, msg) => {
          if (!errs[i]) errs[i] = {};
          // First error per field wins so we don't overwrite a "required"
          // message with a later "must be a number" one.
          if (!errs[i][field]) errs[i][field] = msg;
        };

        let prevEnd = null;
        for (let i = 0; i < formData.step2Data.length; i++) {
          const entry = formData.step2Data[i];
          // Day-off rows skip every required-field / numeric check.
          if (entry?.dayOff) continue;

          // a) base required fields
          for (const f of baseRequiredLogFields) {
            if (isFillerValue(entry[f.key])) {
              addErr(i, f.key, `${f.label} is required.`);
            }
          }
          // a2) fill-up required fields
          if (entry.fillUp) {
            for (const f of fillUpRequiredFields) {
              if (isFillerValue(entry[f.key])) {
                addErr(i, f.key, `${f.label} is required.`);
              }
            }
          }

          const startNum = parseFloat(entry.start);
          const endNum = parseFloat(entry.end);

          // b) base numeric checks (skip if the required check already flagged it)
          if (!errs[i]?.start && (!isFinite(startNum) || startNum < 0)) {
            addErr(i, 'start', 'Mileage Start must be a number.');
          }
          if (!errs[i]?.end && (!isFinite(endNum) || endNum < 0)) {
            addErr(i, 'end', 'Mileage End must be a number.');
          }
          if (isFinite(startNum) && isFinite(endNum) && endNum < startNum) {
            addErr(i, 'end', `Cannot be less than Mileage Start (${startNum}).`);
          }

          // b2) fill-up numeric checks
          if (entry.fillUp) {
            const galNum = parseFloat(entry.gallons);
            const amtNum = parseFloat(entry.amount);
            const mileageNum = parseFloat(entry.milege);
            if (!errs[i]?.gallons && (!isFinite(galNum) || galNum <= 0)) {
              addErr(i, 'gallons', 'Gallons Fuel must be greater than 0.');
            }
            if (!errs[i]?.amount && (!isFinite(amtNum) || amtNum <= 0)) {
              addErr(i, 'amount', 'Total Amount must be greater than 0.');
            }
            if (!errs[i]?.milege && (!isFinite(mileageNum) || mileageNum < 0)) {
              addErr(i, 'milege', 'Mileage @ Repair/Fill-Up must be a number.');
            }
            if (
              isFinite(mileageNum) &&
              isFinite(startNum) &&
              mileageNum < startNum
            ) {
              addErr(
                i,
                'milege',
                `Cannot be less than Mileage Start (${startNum}).`,
              );
            }

            // d) amount vs gallons sanity — kept as a soft inline warning via
            // amountWarnings (not part of `errs`) so the user can override it
            // by re-checking the numbers but it still blocks advancing.
            const warn = validateAmountVsGallons(entry);
            if (warn) {
              setAmountWarnings(prev => ({ ...prev, [i]: warn }));
              addErr(i, 'amount', warn);
            }
          }

          // c) sequential mileage across rows
          if (
            prevEnd !== null &&
            isFinite(startNum) &&
            startNum < prevEnd
          ) {
            addErr(
              i,
              'start',
              `Must be at least ${prevEnd} (previous entry's Mileage End).`,
            );
          }
          if (isFinite(endNum)) prevEnd = endNum;
        }

        if (Object.keys(errs).length > 0) {
          setLogEntryErrors(errs);
          // Soft toast just so it's clear something is wrong — the specific
          // messages are right under each input.
          showError("Please fix the highlighted fields.");
          return;
        }
        setLogEntryErrors({});
        break;
      }
  
      case 3:
        const part1Labels = [
          "ACCIDENT FORM", "BATTERY", "BELTS", "BRAKE FLUID", "ENGINE OIL",
          "FIRE EXTINGUISHER (10lb)", "FIRST AID KIT", "HEADLAMPS & HI-BEAMS",
          "HEATER HOSES", "HITCH, RECEIVER, AND PINS", "HORN", "INSURANCE CARD", "JACK & TIRE IRON"
        ];
  
        for (let label of part1Labels) {
          if (!formData[label]) return showError(`Please fill Vehicle Check (Part 1): ${label}`);
        }
        break;
  
      case 4:
        const part2Labels = [
          "LIGHTS (Parking & BRAKE)", "MIRRORS", "PARKING BRAKE", "RADIATOR FLUID",
          "RADIATOR HOSES", "SEATBELTS", "SPARE TIRE", "STEERING FLUID",
          "TIRE PSI", "TRANSMISSION OIL", "TURN SIGNALS", "WASHER FLUID", "WINDSHIELD WIPERS"
        ];
  
        for (let label of part2Labels) {
          if (!formData[label]) return showError(`Please fill Vehicle Check (Part 2): ${label}`);
        }
        const finalRequiredFields = {
          comments: "Please enter Comments",
          checkedby: "Please enter name in Checked By",
       
        };
 if (!driverSignature && !serverdriverSignature?.file_name) {
    showError('"Please provide a Signature"')
    return
  }
        for (let key in finalRequiredFields) {
          if (!formData[key]) return showError(finalRequiredFields[key]);
        }

        // All validations passed. If the user marked any days as "Day off",
        // ask them to confirm before actually sending the form — they pass
        // `force=true` from the modal's confirm button to skip this check.
        if (!force) {
          const dayOffNames = (formData.step2Data || [])
            .filter((e) => e?.dayOff)
            .map((e) => e?.dayLabel)
            .filter(Boolean);
          if (dayOffNames.length > 0) {
            setDayOffConfirmModal({ open: true, dayOffNames });
            return;
          }
        }

         handleSubmit(); // All validations passed
        return;
    }
 
    // Proceed to next step if validations passed
    if (currentStep < 4) {
      setCurrentStep((prev) => prev + 1);
    }
  };
  
  const showError = (msg) => {
    setSeverity("error");
    setAlertMessage(msg);
    setOpen(true);
    return false;
  };
  
  const steps = [
    'Driver Information',
    'Log Entries',
    'Vehicle Check (Part 1)',
    'Vehicle Check (Part 2)',
  ];

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const fetchEmployeeSuggestions = async (query) => {
    try {
      if (!query) {
        setEmployeeSuggestions([]);
        setShowEmpSuggestions(false);
        return;
      }
  
      const obj = {
        params: {
          company_id:selectedCompanyId,
          empid: query
        },
      };
  
      const response = await api.get("/v1/timesheets/get-employee", obj);
      if (response.status === 200 && Array.isArray(response.data)) {
        setEmployeeSuggestions(response.data);
        setShowEmpSuggestions(true);
      }else{
        setEmployeeSuggestions([]);
        setShowEmpSuggestions(false);
  //       setEmployeeId("")
  //        setFormData((prevFormData) => ({
  //   ...prevFormData,
  //   empname: ''
  // }));
  
      }
    } catch (error) {
      console.error("Error fetching employee suggestions:", error);
    }
  };
  
  const fetchJobSuggestions = async (query) => {
  try {
    if (!query) {
      setSuggestions([]);
      setShowSuggestions(false);
      setSelectedJobName('');
      return;
    }

    // Check for 1 to 4 zeros - return Overhead job directly
    if (/^0{1,4}$/.test(query)) {
      const overheadJob = {
        job_num: "0000",
        job_name: "Overhead",
      };
      setSuggestions([overheadJob]);
      setShowSuggestions(true);
      return;
    }

    const response = await api.get(`/v1/timesheets/get-jobs`, {
      params: {
        company_id: selectedCompanyId,
        job_num: query,
      }
    });

    if (response.status === 200) {
      setSuggestions(response.data || []);
      setShowSuggestions(true);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  } catch (error) {
    console.error("Error fetching jobcodes:", error);
  }
};

  const handleEmployeeSelect = (emp) => {
    setFormData((prev) => ({
      ...prev,
      empname: `${emp.firstname} ${emp.lastname}`,
      emp_Id: emp.empid, // optional: if you want to store the ID
    }));
    setEmployeeId(emp.empid);
    setselectedempobj(emp);
    setShowEmpSuggestions(false);
    setEmployeeSuggestions([]);
  };
  
  const handleJobCodeSelect = (code) => {
    setJobCode(code.job_num);
    setSelectedJobName(code.job_name);
    setSuggestions([]);
    setShowSuggestions(false);
  
    // Also update formData.jobNumber
    setFormData((prev) => ({
      ...prev,
      jobNumber: code.job_num,
    }));
  };
  const mapJsonToForm = (apiData) => {
  const mapped = {
    companyId: apiData.companyid || null,
    emp_Id: apiData.emp_id || null,
    empname: apiData.emp_name || "",
    jobNumber: apiData.job_id || "",
    unitnumber: "",
    fuelallocation:'',
    date: apiData.filled_date || "",
    method: apiData.method || "",
    step2Data: [],
    comments: "",
    checkedby: "",
    signatures: [],
    commentImagesUploaded: [],
  };

  // Pre-seed the local job autocomplete state so the Step-1 Job # input
  // shows as "selected" (matches the save format `${name}-(${code})`).
  // Without this, the onBlur handler wipes the loaded job_id the moment
  // the user tabs out of the field.
  if (apiData.job_id) {
    setJobCode(String(apiData.job_id));
    if (apiData.job_description) {
      const m = String(apiData.job_description).match(/^(.*)-\((.+)\)$/);
      if (m) {
        setSelectedJobName(m[1]);
      } else {
        setSelectedJobName(apiData.job_description);
      }
    }
  }

  // Extract JSON array
  const answers = Array.isArray(apiData.json_data) ? apiData.json_data : [];

  // LABEL GROUPS EXACTLY AS IN YOUR UI
  const part1Labels = [
    "ACCIDENT FORM", "BATTERY", "BELTS", "BRAKE FLUID", "ENGINE OIL",
    "FIRE EXTINGUISHER (10lb)", "FIRST AID KIT", "HEADLAMPS & HI-BEAMS",
    "HEATER HOSES", "HITCH, RECEIVER, AND PINS", "HORN", "INSURANCE CARD",
    "JACK & TIRE IRON"
  ];

  const part2Labels = [
    "LIGHTS (Parking & BRAKE)", "MIRRORS", "PARKING BRAKE", "RADIATOR FLUID",
    "RADIATOR HOSES", "SEATBELTS", "SPARE TIRE", "STEERING FLUID",
    "TIRE PSI", "TRANSMISSION OIL", "TURN SIGNALS", "WASHER FLUID",
    "WINDSHIELD WIPERS"
  ];

  // Map answers back into formData
  answers.forEach((item) => {
    const { question, answer } = item;

    // STEP 1 → Unit Number
    if (question.includes("Unit Number")) {
      mapped.unitnumber = answer;
    }
 
      if (question.includes("Fuel Allocation")) { 
      mapped.fuelallocation = answer;
    }
    // STEP 2 → Log Entries
  if (question === "Driver Log Entries" && Array.isArray(answer)) {
  // Legacy rows didn't store fillUp — infer "true" if any fill-up field has
  // a value, so existing data still surfaces those columns on re-open.
  mapped.step2Data = answer.map((row) => {
    const inferredFillUp =
      !!row.location || !!row.gallons || !!row.amount || !!row.mileage;
    const date = row.date || "";
    const labelFromDate = date
      ? moment(date, 'YYYY-MM-DD').format('dddd')
      : '';
    return {
      dateoflog: date,
      dayLabel: row.dayLabel || labelFromDate,
      dayOff: row.dayOff === true || row.dayOff === 'true',
      milege: row.mileage || "",
      start: row.Start || "",
      end: row.End || "",
      job: row.Job || "",
      fillUp: typeof row.fillUp === 'boolean' ? row.fillUp : inferredFillUp,
      location: row.location || "",
      gallons: row.gallons || "",
      amount: row.amount || ""
    };
  });
  setLogEntries(mapped.step2Data);
  // Anchor the navigator to the week of the first dated entry so the user
  // sees their existing data on the current view instead of an empty week.
  const firstDated = mapped.step2Data.find((r) => r.dateoflog);
  if (firstDated) {
    const wkStart = moment(firstDated.dateoflog, 'YYYY-MM-DD')
      .startOf('isoWeek')
      .format('YYYY-MM-DD');
    setSelectedWeekStart(wkStart);
  }
}



    // STEP 3 (Part 1)
    part1Labels.forEach((label) => {
      if (question.includes(label)) mapped[label] = answer;
    });

    // STEP 4 (Part 2)
    part2Labels.forEach((label) => {
      if (question.includes(label)) mapped[label] = answer;
    });

    // COMMENTS
    if (question === "Comments") mapped.comments = answer;

    // CHECKED BY
    if (question === "Checked By") mapped.checkedby = answer;

    // SIGNATURE
    if (question === "Signature" && Array.isArray(answer)) {
      mapped.signatures = answer; // backend returns array of files
      setServerDriverSignature(answer[0]); // assuming single signature
    }

    // COMMENT IMAGES — accept both the web key ("Comments - Uploaded Images")
    // and the mobile-app key ("Upload Images") so edit mode shows previously
    // uploaded photos regardless of which client saved the form.
    if (
      question === "Comments - Uploaded Images" ||
      question === "Upload Images"
    ) {
      const imgs = Array.isArray(answer) ? answer : [];
      mapped.commentImagesUploaded = imgs;
      setEditedCommentImages(imgs);
    }
  });
console.log("Mapped form data from API:", mapped);
  return mapped;
};

  const fetchcurrentformdata=async()=>{
    try {
      setLoader(true)
       const res = await api.get(`/v1/forms/get_by_id`,{
        params:{
            rowid:id
          }
        });
     if (res.status === 200) {
        const apiData = res.data[0];
  
       let mapped = mapJsonToForm(apiData);
  
        setFormData(mapped);
      }
      
    } catch (error) {
      console.log(error)
    }finally{
  setLoader(false)
    }
  }
  useEffect(() => {
    if (mode === "edit" && id) {
    fetchcurrentformdata()
    }
  }, [mode, id]);
    const fetchTabsData = async () => {
      try {
        const response = await api.get(`/v1/timesheets/company-details`);
    
        if (response.status === 200 ) {
          setCompanyTabs(response.data);
          setSelectedCompanyId(response.data[0]?.id);
        }else{
        
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }finally{
        
      }
    };
    const fetchpm=async(id)=>{
      try {
        setLoader(true)
        const response =await api.get(`/v1/companies/${id}/project-managers`)
        if(response.status==200){
setpmolist(response?.data||[])
        }
      } catch (error) {
        console.log(error)
      }finally{
setLoader(false)
      }
    }
    useEffect(()=>{
      fetchTabsData()
    },[])
  
    const handleInputChange = (e, section, field) => {
      const { value } = e.target;
      if (section) {
        setFormData(prev => ({
          ...prev,
          [section]: {
            ...prev[section],
            [field]: value
          }
        }));
      } else {
        setFormData(prev => ({
          ...prev,
          [field]: value
        }));
      }
    };
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (jobInputRef.current && !jobInputRef.current.contains(event.target)) {
          setShowSuggestions(false);
        }
   
        if (empInputRef.current && !empInputRef.current.contains(event.target)) {
          setShowEmpSuggestions(false);
        }
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleDeleteEntry = (index) => {
      const updatedEntries = logEntries.filter((_, i) => i !== index);
      setLogEntries(updatedEntries);
      setFormData((prev) => ({
        ...prev,
        step2Data: updatedEntries,
      }));
    };
    const combinedImages = [
  ...editedCommentedImages.map(img => ({
    type: "server",
    preview: `https://hub2.ntactops.com/ntact/files/forms_files/${img.file_name}`,
    data: img
  })),
  ...commentImages.map(img => ({
    type: "local",
    preview: img.preview,
    data: img
  }))
];
const handleRemove = (index) => {
  const serverCount = editedCommentedImages.length;

  // Removing server image
if (index < serverCount) {
  const updatedServer = editedCommentedImages.filter((_, i) => i !== index);

  // 👈 THIS IS THE FIX — Update UI state
  setEditedCommentImages(updatedServer);

  // 👈 Update form submit data
  setFormData(prev => ({
    ...prev,
    commentImagesUploaded: updatedServer,
  }));

  return;
}


  // Removing local image
  const localIndex = index - serverCount;
  const updatedLocal = commentImages.filter((_, i) => i !== localIndex);

  setCommentImages(updatedLocal);

  setFormData(prev => ({
    ...prev,
    commentImages: updatedLocal.map(img => img.file)
  }));
};


  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    const newCommentImages = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    setCommentImages((prev) => [...prev, ...newCommentImages]);

    setFormData((prev) => ({
      ...prev,
      commentImages: [...(prev.commentImages || []), ...files],
    }));
  };
  const handleRemoveImage = (index) => {
    const updatedCommentImages = commentImages.filter((_, i) => i !== index);
    setCommentImages(updatedCommentImages);

    setFormData((prev) => ({
      ...prev,
      commentImages: prev.commentImages.filter((_, i) => i !== index),
    }));
  };
  return (
    <div className="p-5">
      {/* Top Step Indicator */}
      <div className="flex items-center justify-between w-full mb-6 relative">
        <div className='absolute mb-[75px] left-1 flex items-center'>
          <div className='flex items-center'>
              <FiArrowLeft onClick={() => navigate(-1)} className="text-xl mt-2 mr-4 cursor-pointer" />
          </div>
        {currentStep !== 2 && (
          <div className=" font-inter text-sm mt-2 text-gray-600">
            Page {currentStep} of {steps.length}
          </div>
        )}
        <div className='mt-2 ml-6'>
        <h2 className="text-lg font-inter  font-semibold">{t("WEEKLY DRIVER LOG & SAFETY")}</h2>
        </div>

        </div>

        {steps.map((step, index) => (
          <div key={index} className="text-center mx-8 mt-10 w-full flex items-center flex-col">
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center mb-1 text-sm ${
                currentStep === index + 1
                  ? 'bg-black text-white'
                  : 'bg-gray-200 text-black'
              }`}
            >
              {index + 1}
            </div>
            <div className="text-xs font-inter">{t(step)}</div>
          </div>
        ))}
      </div>
      {currentStep === 2 && (
        <>
          <div className="flex w-full justify-between mb-2 px-20">
            <div className="font-inter text-sm text-gray-600">
              Step {currentStep} of {steps.length}
            </div>
            <p className="font-inter text-sm">{Math.round((currentStep / steps.length) * 100)}%</p>
          </div>
          {/* Progress Bar */}
          <div className="w-full mb-4 px-20">
            <div className="bg-gray-200 h-2 rounded-full">
              <div
                className="bg-black h-2 rounded-full transition-all duration-300"
                style={{ width: `${(currentStep / steps.length) * 100}%` }}
              ></div>
            </div>
          </div>
        </>
      )}
           <div className="m-2 flex justify-end w-full px-20">
      <button
        onClick={() => changeLanguage('en')}
        className={`px-3 py-1 rounded ${selectedLanguage === 'en' ? 'bg-black text-white' : 'bg-white text-black border border-gray-300'}`}
      >
        English
      </button>
      <button
        onClick={() => changeLanguage('es')}
        className={`px-3 py-1 rounded ${selectedLanguage === 'es' ? 'bg-black text-white' : 'bg-white text-black border border-gray-300'}`}
      >
        Español
      </button>
    </div>

      {/* Form Content */}
      <div className="w-full flex items-center justify-center">
        <div className="bg-white rounded-lg shadow-md overflow-hidden w-[90%]">
          {/* Step Title */}
          <div className="flex bg-black text-white font-semibold font-inter p-4">
          {t("Step")}{currentStep}: 
            {currentStep === 3 ? t("Vehicle Safety Check (Part-1)") : 
             currentStep === 4 ? t("Vehicle Safety Check") + " " + t("(Part-2)") + " " + t("& Comments"): 
             t(steps[currentStep - 1])}
          </div>
          

          {/* Step Content */}
          <div className="p-6">
            {currentStep === 1 && (
              <>
                <h3 className="font-bold mb-6 text-lg text-left">{t("Driver Information")}</h3>
                <div className='flex gap-6  mb-4'>
                <div className='flex-1'>
      <label className="block text-sm text-left font-medium">{t("Method")}
      </label>
      <select
  className="w-full border rounded px-3 py-[10px]  text-sm font-inter mt-1"
  value={formData.method || ""}
  onChange={(e) => {
    setFormData((prev) => ({
      ...prev,
      method: e.target.value,
    }));
  }}
>
  <option className="font-inter text-xs" value="">{t("Select Method")}</option>
  <option className="font-inter text-xs" value="Filled Out">{t("Filled Out")}</option>
  <option className="font-inter text-xs" value="Uploaded">{t("Uploaded")}</option>
  <option className="font-inter text-xs" value="Capture">{t("Capture")}</option>
</select>
    </div>
                  <div className="flex-1">
                <label className="block font-bold text-sm text-left">{t("Company ID")}</label>
<select
  className="w-full border rounded px-3 py-[10px] text-sm font-inter mt-1"
  value={formData.companyId || ""}
  onChange={(e) => {
    const selectedId = e.target.value ? parseInt(e.target.value, 10) : null;
         setSelectedCompanyId(selectedId)
    setFormData((prev) => ({
      ...prev,
      companyId: selectedId,
    }));
    // fetchpm(selectedId)
  }}
>
  <option className="font-inter text-xs" value="">{t("Select a Company")}</option>
  {companyTabs.map((company) => (
    <option className="font-inter text-xs" key={company.id} value={company.id}>
      {t(company.name)}
    </option>
  ))}
</select>



                   </div>
                    {/* <div className="flex-1">
                <label className="block font-bold text-sm text-left">{t("Project Manger")}</label>
<select
  className="w-full border rounded px-3 py-[10px] text-sm font-inter mt-1"
  value={formData.pm_id || ""}
   onChange={(e) => {
    const selectedId = e.target.value ? parseInt(e.target.value, 10) : null;
    const selectedPM = pmolist.find((pmoo) => pmoo.id === selectedId);
    const selectedName = selectedPM ? `${selectedPM.firstname} ${selectedPM.lastname}` : "";

    setFormData((prev) => ({
      ...prev,
      pm_id: selectedId,
      pm_name: selectedName,
    }));
  }}
>
  <option className="font-inter text-xs" value="">{t("Select Project Manager")}</option>
  {pmolist.map((pmoo) => (
    <option className="font-inter text-xs" key={pmoo.id} value={pmoo.id}>
      {t(pmoo?.firstname+" "+pmoo?.lastname)}
    </option>
  ))}
</select>



                   </div> */}
                   <div className="flex-1 relative" ref={jobInputRef}>
                <label className="block font-bold text-sm  mb-1 text-left">{t("JOB")} #</label>
                <input
                    placeholder='Enter job Id'
                  type="text"
                  className="w-full border border-gray-300 rounded p-2 text-sm"
                  value={formData.jobNumber}
                  onChange={(e) => {
                    const val = e.target.value;
  

                    handleInputChange({ target: { value: val } }, null, 'jobNumber');
                    
                    if (!val.trim()) {
                      setSuggestions([]);
                      setShowSuggestions(false);
                    } else {
                      fetchJobSuggestions(val); // your function to get suggestions
                      setShowSuggestions(true);
                    }
                  }}
                     onBlur={() => {
    // Only run the "must match a suggestion" wipe when there's actually a
    // dropdown to compare against — otherwise we wipe a freshly hydrated
    // value in edit mode (where no fetch has happened) or any value the
    // user already locked in earlier (jobCode is set after a pick).
    if (suggestions.length === 0) return;
    if (formData.jobNumber && formData.jobNumber === jobCode) return;
    const isValid = suggestions.some((s) => s.job_num === formData.jobNumber);
    if (!isValid) {
      setFormData((prev) => ({
        ...prev,
        jobNumber: '',
      }));
      setJobCode('');
      setSelectedJobName('');
    }
  }}
  onKeyDown={(e) => {
    if (e.key === 'Tab' && suggestions?.length) {
      handleJobCodeSelect(suggestions[0]);
      e.preventDefault();
    }
    if (e.key === 'ArrowDown') {
      setHoveredJobIndex((prev) =>
        prev === null || prev === suggestions.length - 1 ? 0 : prev + 1
      );
    }
    if (e.key === 'ArrowUp') {
      setHoveredJobIndex((prev) =>
        prev === null || prev === 0 ? suggestions.length - 1 : prev - 1
      );
    }
  }}
                />
                   {showSuggestions && suggestions.length > 0 && (
                <ul className="absolute z-10 mt-1 left-0 text-start bg-white border border-gray-200 rounded-md shadow-lg max-h-[400px] overflow-y-auto text-sm w-full whitespace-nowrap">
                  {suggestions.map((code, index) => (
                    <li
                      key={index}
                      onClick={() => handleJobCodeSelect(code)}
                       onMouseEnter={() => setHoveredJobIndex(index)}
        className={`px-2 py-1 cursor-pointer hover:bg-gray-100 ${
          index === hoveredJobIndex ? 'bg-gray-100' : ''
        }`}
                    >
                      {code.job_num} - {code.job_name}
                    </li>
                  ))}
                </ul>
              )}
              </div>
         
                </div>
                <div className="flex gap-6 mb-6">
                <div className="flex-1">
                <label className="block font-bold text-md mb-2 text-left">{t("DRIVER")}</label>
                <div className="relative" ref={empInputRef}>
  <input
    type="text"
    placeholder='Enter Employee id'
    className="w-full border border-gray-300 rounded p-2 py-2.5 text-sm"
    value={formData.empname}
    onChange={(e) => {
      const val = e.target.value;
  

      handleInputChange(e, null, 'empname');
      if (!val.trim()) {
        setselectedempobj({});
        setEmployeeSuggestions([]);
        setShowEmpSuggestions(false);
      } else {
        fetchEmployeeSuggestions(val);
      }
    }}
     onBlur={() => {
      // If no suggestion was selected, clear the input field
      if (!selectedempobj || Object.keys(selectedempobj).length === 0) {
        setFormData((prev) => ({
          ...prev,
          empname: '', // Clear the empname input
        }));
      }
    }}
      onKeyDown={(e) => {
    if (e.key === 'Tab' && employeeSuggestions?.length) {
      handleEmployeeSelect(employeeSuggestions[0]);
      e.preventDefault();
    }
    if (e.key === 'ArrowDown') {
      setHoveredEmpIndex((prev) =>
        prev === null || prev === employeeSuggestions.length - 1 ? 0 : prev + 1
      );
    }
    if (e.key === 'ArrowUp') {
      setHoveredEmpIndex((prev) =>
        prev === null || prev === 0 ? employeeSuggestions.length - 1 : prev - 1
      );
    }
  }}
  />
  {showEmpSuggestions && employeeSuggestions.length > 0 && (
    <ul className="absolute z-10 mt-1 left-0 text-start bg-white border border-gray-200 rounded-md shadow-lg max-h-[300px] overflow-y-auto text-sm w-full">
      {employeeSuggestions.map((emp, index) => (
        <li
          key={index}
          onClick={() => handleEmployeeSelect(emp)}
          onMouseEnter={() => setHoveredEmpIndex(index)}
        className={`px-2 py-1 cursor-pointer hover:bg-gray-100 ${
          index === hoveredEmpIndex ? 'bg-gray-100' : ''
        }`}
        >
          {`${emp.firstname} ${emp.lastname}`} - {emp.empid}
        </li>
      ))}
    </ul>
  )}
                  </div>

              </div>
                  {/* <div className="flex-1">
                    <label className="block font-bold mb-2 text-left">DRIVER:</label>
                    <input
                      type="text"
                      placeholder="Enter driver name"
                      value={formData.drivername}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          drivername: e.target.value,
                        }))
                      }
                      className="w-full p-2 border border-gray-300 rounded-md"
                    />
                  </div> */}

                       <div className="flex-1">
                    <label className="block font-bold mb-2 text-left">{t("DATE")}:</label>
    <DatePicker
  selected={formData.date ? new Date(formData.date + 'T00:00:00') : null} // Ensure local date parsing
  onChange={(date) =>
    setFormData((prev) => {
      const formattedDate = date
        ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
        : '';
   
      return {
        ...prev,
        date: formattedDate, // Store as yyyy-MM-dd in local time
      };
    })
  }
  className="w-full p-2 border border-gray-300 rounded-md"
  wrapperClassName="w-full"
  dateFormat="MM-dd-yyyy" // Display format as MM-dd-yyyy
  maxDate={new Date()} // Disables future dates
  placeholderText="MM-DD-YYYY" // Improves UX
/>


                  </div>
                  <div className="flex items-end gap-6">
  {/* Fuel Allocation checkboxes */}
  <div className="flex flex-col items-start gap-2">
    <div className="font-bold mb-4">Fuel Allocation:</div>
<div className='flex gap-3'>


   <label className="flex items-center gap-2">
      <input
        type="checkbox"
        checked={formData.fuelallocation === "vehicle"}
        onChange={() =>
          setFormData((prev) => ({
            ...prev,
            fuelallocation:
              prev.fuelallocation === "vehicle" ? "" : "vehicle",
            unitnumber: "",
          }))
        }
      />
      Vehicle
    </label>

    <label className="flex items-center gap-2">
      <input
        type="checkbox"
        checked={formData.fuelallocation === "equipment"}
        onChange={() =>
          setFormData((prev) => ({
            ...prev,
            fuelallocation:
              prev.fuelallocation === "equipment" ? "" : "equipment",
            unitnumber: "",
          }))
        }
      />
      Equipment
    </label>
</div>
   
  </div>

  {/* Show input only when selected */}
  {formData.fuelallocation && (
    <div className="flex-1">
      <label className="block font-bold mb-2 text-left">
        {formData.fuelallocation === "equipment"
          ? "Equipment Description"
          : `${t("UNIT")} #`}
      </label>

      <input
        type="text"
        placeholder={
          formData.fuelallocation === "equipment"
            ? "Enter equipment description"
            : "Enter unit number"
        }
        value={formData.unitnumber}
        onChange={(e) =>
          setFormData((prev) => ({
            ...prev,
            unitnumber: e.target.value,
          }))
        }
        className="w-full p-2 border border-gray-300 rounded-md"
      />
    </div>
  )}
</div>

                  {/* <div className="flex-1">
                    <label className="block font-bold mb-2 text-left">{t("UNIT")} #:</label>
                    <input
                      type="text"
                      placeholder="Enter unit number"
                      value={formData.unitnumber}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          unitnumber: e.target.value,
                        }))
                      }
                      className="w-full p-2 border border-gray-300 rounded-md"
                    />
                    {formData.fuelallocation}
                  </div> */}
             
                </div>

                {/* Red Note */}
                <div className="bg-red-100 text-red-600 font-semibold text-center px-20 py-3 text-md border-t-2 border-b-2">
                {t("NOTE: SEAT BELTS SHALL BE WORN ANY TIME VEHICLE IS IN MOTION.")}
                  {t("THIS LOG SHALL BE KEPT DAILY AND TURNED IN WEEKLY.")}
                </div>
              </>
            )}

            {currentStep === 2 && (
              <>
                <h3 className="font-inter mb-6 text-left">{t("Driver Log Entries")}</h3>

                {/* Week navigator — prev / next / current-week label. Future
                    weeks are blocked. Switching weeks resets the 7 cards to
                    the new week's skeleton. */}
                <div className="flex items-center justify-between mb-4 bg-gray-50 border border-gray-200 rounded-lg px-3 py-2">
                  <button
                    type="button"
                    onClick={goToPrevWeek}
                    className="px-3 py-1.5 rounded-md border border-gray-300 bg-white hover:bg-gray-100 text-sm font-medium"
                    title="Previous week"
                  >
                    ← {t("Previous")}
                  </button>
                  <div className="text-sm font-semibold text-gray-800">
                    {selectedWeekLabel}
                  </div>
                  <button
                    type="button"
                    onClick={goToNextWeek}
                    disabled={isAtCurrentWeek}
                    className={`px-3 py-1.5 rounded-md border text-sm font-medium ${
                      isAtCurrentWeek
                        ? "border-gray-200 text-gray-300 bg-gray-50 cursor-not-allowed"
                        : "border-gray-300 bg-white hover:bg-gray-100"
                    }`}
                    title="Next week"
                  >
                    {t("Next")} →
                  </button>
                </div>

                {/* One card per day of the selected week. Day-off toggle hides
                    the data fields; FILL-UP toggle reveals the four extras. */}
                <div className="space-y-4">
                  {logEntries.map((entry, index) => {
                    const cardDate = entry.dateoflog
                      ? moment(entry.dateoflog, 'YYYY-MM-DD').format('MMM D')
                      : '';
                    return (
                      <div
                        key={index}
                        className={`border rounded-lg ${
                          entry.dayOff
                            ? "border-gray-200 bg-gray-50"
                            : "border-gray-300 bg-white"
                        }`}
                      >
                        {/* Card header — weekday + date on the left, Day off on the right.
                            Keeps `rounded-t-lg` (not `overflow-hidden` on the card) so the
                            JOB # autocomplete dropdown isn't clipped by the card bounds. */}
                        <div className="flex items-center justify-between px-4 py-2 border-b border-gray-200 bg-gray-100 rounded-t-lg">
                          <div className="font-inter font-semibold text-sm text-gray-800">
                            {t(entry.dayLabel) || entry.dayLabel}
                            {cardDate ? `, ${cardDate}` : ""}
                          </div>
                          <label className="flex items-center gap-2 cursor-pointer select-none">
                            <input
                              type="checkbox"
                              className="w-4 h-4 cursor-pointer accent-red-500"
                              checked={!!entry.dayOff}
                              onChange={(e) =>
                                handleEntryChange(index, 'dayOff', e.target.checked)
                              }
                            />
                            <span className="text-sm font-medium text-gray-700">
                              {t("Day off")}
                            </span>
                          </label>
                        </div>

                        {!entry.dayOff && (
                          <div className="p-4 space-y-3">
                            {/* Mileage Start / Mileage End */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                              <div>
                                <label className="block text-xs font-semibold font-inter text-gray-600 mb-1 text-left">
                                  {t("MILEAGE START")}
                                </label>
                                <input
                                  type="text"
                                  placeholder={t("Start")}
                                  value={entry.start}
                                  onChange={(e) =>
                                    handleEntryChange(index, 'start', e.target.value)
                                  }
                                  onBlur={() => handleEntryBlur(index, 'start')}
                                  className={`w-full rounded-md p-2 text-sm border ${
                                    logEntryErrors[index]?.start
                                      ? "border-red-500 focus:outline-none focus:ring-1 focus:ring-red-500"
                                      : "border-gray-300"
                                  }`}
                                />
                                {logEntryErrors[index]?.start && (
                                  <p className="text-xs text-red-600 mt-1 text-left">
                                    {logEntryErrors[index].start}
                                  </p>
                                )}
                              </div>
                              <div>
                                <label className="block text-xs font-semibold font-inter text-gray-600 mb-1 text-left">
                                  {t("MILEAGE END")}
                                </label>
                                <input
                                  type="text"
                                  placeholder={t("End")}
                                  value={entry.end}
                                  onChange={(e) =>
                                    handleEntryChange(index, 'end', e.target.value)
                                  }
                                  onBlur={() => handleEntryBlur(index, 'end')}
                                  className={`w-full rounded-md p-2 text-sm border ${
                                    logEntryErrors[index]?.end
                                      ? "border-red-500 focus:outline-none focus:ring-1 focus:ring-red-500"
                                      : "border-gray-300"
                                  }`}
                                />
                                {logEntryErrors[index]?.end && (
                                  <p className="text-xs text-red-600 mt-1 text-left">
                                    {logEntryErrors[index].end}
                                  </p>
                                )}
                              </div>
                            </div>

                            {/* JOB # with autocomplete */}
                            <div className="relative">
                              <label className="block text-xs font-semibold font-inter text-gray-600 mb-1 text-left">
                                {t("JOB #")}
                              </label>
                              <input
                                type="text"
                                placeholder="Job #"
                                value={entry.job}
                                onChange={(e) => {
                                  const v = e.target.value;
                                  handleEntryChange(index, 'job', v);
                                  setOpenJobEntryIndex(index);
                                  setEntryJobSuggestions([]);
                                  if (v) fetchEntryJobSuggestions(v);
                                }}
                                onFocus={() => setOpenJobEntryIndex(index)}
                                className={`w-full rounded-md p-2 text-sm border ${
                                  logEntryErrors[index]?.job
                                    ? "border-red-500 focus:outline-none focus:ring-1 focus:ring-red-500"
                                    : "border-gray-300"
                                }`}
                              />
                              {logEntryErrors[index]?.job && (
                                <p className="text-xs text-red-600 mt-1 text-left">
                                  {logEntryErrors[index].job}
                                </p>
                              )}
                              {openJobEntryIndex === index &&
                                !!entry.job &&
                                entryJobSuggestions.length > 0 && (
                                  <ul className="absolute z-20 mt-1 w-full max-h-60 overflow-y-auto bg-white border border-gray-200 rounded-md shadow-lg">
                                    {entryJobSuggestions.map((jobItem) => (
                                      <li key={jobItem.job_num}>
                                        <button
                                          type="button"
                                          onClick={() => {
                                            handleEntryChange(index, 'job', jobItem.job_num);
                                            setOpenJobEntryIndex(null);
                                            setEntryJobSuggestions([]);
                                          }}
                                          className="w-full text-left px-3 py-2 text-sm hover:bg-gray-50 border-b border-gray-100 last:border-b-0"
                                        >
                                          <span className="font-medium text-gray-800">
                                            {jobItem.job_num}
                                          </span>{" "}
                                          <span className="text-gray-600">
                                            — {jobItem.job_name}
                                          </span>
                                        </button>
                                      </li>
                                    ))}
                                  </ul>
                                )}
                            </div>

                            {/* Fill-up toggle */}
                            <label className="flex items-center gap-2 cursor-pointer select-none pt-1">
                              <input
                                type="checkbox"
                                className="w-4 h-4 cursor-pointer accent-red-500"
                                checked={!!entry.fillUp}
                                onChange={(e) =>
                                  handleEntryChange(index, 'fillUp', e.target.checked)
                                }
                              />
                              <span className="text-sm font-medium text-gray-700">
                                {t("Fill up")}
                              </span>
                            </label>

                            {entry.fillUp && (
                              <div className="space-y-3 pt-1">
                                <div>
                                  <label className="block text-xs font-semibold font-inter text-gray-600 mb-1 text-left">
                                    {t("REPAIR/FILL-UP LOCATION")}
                                  </label>
                                  <input
                                    type="text"
                                    placeholder={t("Location")}
                                    value={entry.location}
                                    onChange={(e) =>
                                      handleEntryChange(index, 'location', e.target.value)
                                    }
                                    className={`w-full rounded-md p-2 text-sm border ${
                                      logEntryErrors[index]?.location
                                        ? "border-red-500 focus:outline-none focus:ring-1 focus:ring-red-500"
                                        : "border-gray-300"
                                    }`}
                                  />
                                  {logEntryErrors[index]?.location && (
                                    <p className="text-xs text-red-600 mt-1 text-left">
                                      {logEntryErrors[index].location}
                                    </p>
                                  )}
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                  <div>
                                    <label className="block text-xs font-semibold font-inter text-gray-600 mb-1 text-left">
                                      {t("GALLONS FUEL")}
                                    </label>
                                    <input
                                      type="text"
                                      placeholder={t("Gallons")}
                                      value={entry.gallons}
                                      onChange={(e) =>
                                        handleEntryChange(index, 'gallons', e.target.value)
                                      }
                                      onBlur={() => handleEntryBlur(index, 'gallons')}
                                      className={`w-full rounded-md p-2 text-sm border ${
                                        logEntryErrors[index]?.gallons || amountWarnings[index]
                                          ? "border-red-500 focus:outline-none focus:ring-1 focus:ring-red-500"
                                          : "border-gray-300"
                                      }`}
                                    />
                                    {logEntryErrors[index]?.gallons && (
                                      <p className="text-xs text-red-600 mt-1 text-left">
                                        {logEntryErrors[index].gallons}
                                      </p>
                                    )}
                                  </div>
                                  <div>
                                    <label className="block text-xs font-semibold font-inter text-gray-600 mb-1 text-left">
                                      {t("TOTAL AMOUNT")}
                                    </label>
                                    <input
                                      type="text"
                                      placeholder={t("Amount")}
                                      value={entry.amount}
                                      onChange={(e) =>
                                        handleEntryChange(index, 'amount', e.target.value)
                                      }
                                      onBlur={() => handleEntryBlur(index, 'amount')}
                                      className={`w-full rounded-md p-2 text-sm border ${
                                        logEntryErrors[index]?.amount || amountWarnings[index]
                                          ? "border-red-500 focus:outline-none focus:ring-1 focus:ring-red-500"
                                          : "border-gray-300"
                                      }`}
                                    />
                                    {(logEntryErrors[index]?.amount || amountWarnings[index]) && (
                                      <p className="text-xs text-red-600 mt-1 text-left">
                                        {logEntryErrors[index]?.amount || amountWarnings[index]}
                                      </p>
                                    )}
                                  </div>
                                </div>
                                <div>
                                  <label className="block text-xs font-semibold font-inter text-gray-600 mb-1 text-left">
                                    {t("MILEAGE @ REPAIR/FILL-UP")}
                                  </label>
                                  <input
                                    type="text"
                                    placeholder={t("Mileage")}
                                    value={entry.milege}
                                    onChange={(e) =>
                                      handleEntryChange(index, 'milege', e.target.value)
                                    }
                                    className={`w-full rounded-md p-2 text-sm border ${
                                      logEntryErrors[index]?.milege
                                        ? "border-red-500 focus:outline-none focus:ring-1 focus:ring-red-500"
                                        : "border-gray-300"
                                    }`}
                                  />
                                  {logEntryErrors[index]?.milege && (
                                    <p className="text-xs text-red-600 mt-1 text-left">
                                      {logEntryErrors[index].milege}
                                    </p>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </>
            )}

            {currentStep === 3 && (
              <>
                <div className="mb-4">
                <div className="flex items-center text-red-500 mb-2">
  <img src={redtick} className="w-6 h-6" alt="Red Tick" />
  <h2 className="text-black text-md font-bold ml-2">{t("Weekly Vehicle Safety Check")}</h2>
</div>
<p className="flex font-inter text-gray-500 text-xs">
  {t("Check YES for good condition, NO if item requires attention (add comment)")}
</p>
</div>

                <div className="border border-gray-200 rounded-lg overflow-hidden">
                <div className="flex bg-gray-200 p-3 font-semibold">
    {t("Vehicle Components (Part 1)")}
  </div>
                  <div>
                    <table className="w-full table-auto">
                      <tbody className="[&>tr>td]:py-2 [&>tr>td]:px-2 ">
                        {groupedItems.map((row, rowIndex) => (
                          <tr key={rowIndex} className="w-full ">
                            {row.map((item, colIndex) => (
                              item ? (
                                <React.Fragment key={colIndex}>
                                  <td className="text-gray-700 border-t font-inter text-xs  text-left ml-2">{t(item)}</td>
                                  <td className="border-t border-r ">
                                    <div className="flex items-center gap-4">
                                      <label className="flex items-center gap-1">
                                        <input
                                          type="radio"
                                          name={item}
                                          value="Yes"
                                          checked={formData[item] === "Yes"}
                                          onChange={() => handleRadioChange(item, "Yes")}
                                          className="text-green-500 cursor-pointer"
                                        />
                                        <span className="text-green-600 font-inter text-xs">{t("YES")}</span>
                                      </label>
                                      <label className="flex items-center gap-1">
                                        <input
                                          type="radio"
                                          name={item}
                                          value="No"
                                          checked={formData[item] === "No"}
                                          onChange={() => handleRadioChange(item, "No")}
                                          className="text-red-500 cursor-pointer"
                                        />
                                        <span className="text-red-600 font-inter text-xs">NO</span>
                                      </label>
                                    </div>
                                  </td>
                                </React.Fragment>
                              ) : (
                                <>
                                  <td></td><td></td>
                                </>
                              )
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}

            {currentStep === 4 && (
              <>
                {/* Table */}
                <div className="border border-gray-200 rounded-lg overflow-hidden">
                  <div className="flex bg-gray-100 p-3 font-semibold">
                  {t("Vehicle Components (Part 2)")}
                  </div>
                  <div>
                    <table className="w-full table-auto">
                      <tbody className="[&>tr>td]:py-2 [&>tr>td]:px-2">
                        {step4groupedItems.map((row, rowIndex) => (
                          <tr key={rowIndex}>
                            {row.map((item, colIndex) => (
                              item ? (
                                <React.Fragment key={colIndex}>
                                  <td className="text-gray-700 border-t font-inter text-sm text-left ml-2">{t(item)}</td>
                                  <td className="border-t border-r">
                                    <div className="flex items-center gap-4">
                                      <label className="flex items-center gap-1">
                                        <input
                                          type="radio"
                                          name={item}
                                          value="Yes"
                                          checked={formData[item] === "Yes"}
                                          onChange={() => handleRadioChange(item, "Yes")}
                                          className="text-green-500 cursor-pointer"
                                        />
                                        <span className="text-green-600 font-inter text-xs">{t("YES")}</span>
                                      </label>
                                      <label className="flex items-center gap-1">
                                        <input
                                          type="radio"
                                          name={item}
                                          value="No"
                                          checked={formData[item] === "No"}
                                          onChange={() => handleRadioChange(item, "No")}
                                          className="text-red-500 cursor-pointer"
                                        />
                                        <span className="text-red-600 font-inter text-xs">NO</span>
                                      </label>
                                    </div>
                                  </td>
                                </React.Fragment>
                              ) : (
                                <>
                                  <td></td><td></td>
                                </>
                              )
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Comments Section */}
                <div className="mt-6 border border-gray-200 rounded-lg overflow-hidden">
                  <span className="flex block bg-gray-100 p-3 text-gray-700">
                    <img src={wrong} className="w-4 h-4 mt-[5px] mr-2" alt="Red Tick" />
                    {t("Comments")}<br />
                  </span>
                  <span className="flex text-gray-700 bg-gray-100 p-3">{t("Note any items or repairs needed")}</span>
                  <textarea
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        comments: e.target.value,
                      }))
                    }
                    value={formData.comments}
                    rows="4"
                    placeholder="Enter any comments or notes about repairs needed..."
                    className="w-full my-2 p-2 border border-gray-300 rounded-md"
                  ></textarea>
                   <div className="p-3 border-t border-gray-200 bg-gray-50">
        <label
          htmlFor="upload"
          className="flex items-center gap-2 cursor-pointer text-sm text-blue-600 hover:text-blue-800"
        >
          <FontAwesomeIcon icon={faUpload} />
          <span>{t("Upload Images")}</span>
        </label>
        <input
          id="upload"
          type="file"
          multiple
          accept="image/*"
          className="hidden"
          onChange={handleImageUpload}
        />

   
        {/* {commentImages.length > 0 && (
          <div className="flex flex-wrap mt-3 gap-3">
            {commentImages.map((img, index) => (
              <div
                key={index}
                className="relative w-24 h-24 border border-gray-300 rounded-lg overflow-hidden"
              >
                <img
                  src={img.preview}
                  alt={`comment-preview-${index}`}
                  className="object-cover w-full h-full"
                />
                <button
                  type="button"
                  onClick={() => handleRemoveImage(index)}
                  className="absolute top-1 right-1 bg-black bg-opacity-50 text-white rounded-full p-1 hover:bg-opacity-70"
                >
                  <FontAwesomeIcon icon={faTimes} size="xs" />
                </button>
              </div>
              
            ))}
          </div>
        )} */}
        {/* Image Preview Section */}
{combinedImages.length > 0 && (
  <div className="flex flex-wrap mt-3 gap-3">

    {combinedImages.map((img, index) => (
      <div
        key={index}
        className="relative w-24 h-24 border border-gray-300 rounded-lg overflow-hidden"
      >
        <img
          src={img.preview}
          alt={`img-${index}`}
          className="object-cover w-full h-full"
        />

        <button
          type="button"
          onClick={() => handleRemove(index)}
          className="absolute top-1 right-1 bg-black bg-opacity-50 text-white rounded-full p-1 hover:bg-opacity-70"
        >
          <FontAwesomeIcon icon={faTimes} size="xs" />
        </button>
      </div>
    ))}

  </div>
)}


      </div>
                </div>
                <div className="flex gap-6 mb-6 mt-6 p-4 bg-gray-100 border-t border-gray-200 overflow-hidden">
                  <div className="flex flex-col w-[50%]">
                    <label className="text-gray-700 flex bg-gray-100 p-3 font-semibold text-md">{t("CHECKED BY:")}</label>
                    <input
                      type="text"
                      placeholder="Enter name"
                      value={formData.checkedby}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          checkedby: e.target.value,
                        }))
                      }
                      className="w-full p-2 border border-gray-300 rounded-md"
                    />
                  </div>
                  <div className="flex flex-col w-[50%]">
                    <label className="text-gray-700 flex bg-gray-100 p-3 font-bold font-semibold text-md">{t("DRIVER SIGNATURE:")}</label>
                    <input
                      type="text"
                      onClick={()=>{
                        setSignatureModal(true)
                      }}
                      // value={formData.sign}
                      // onChange={(e) =>
                      //   setFormData((prev) => ({
                      //     ...prev,
                      //     sign: e.target.value,
                      //   }))
                      // }
                      placeholder="sign here"
                      className="w-full p-2 border border-gray-300 rounded-md"
 acoperă />
   {driverSignature? (
      <img
        className="w-40 h-24 mt-4 object-contain border border-gray-200 rounded-md bg-white"
        src={
          driverSignature instanceof File
            ? URL.createObjectURL(driverSignature)
            : driverSignature
        }
        alt="Supervisor Signature"
        onLoad={(e) => {
          if (driverSignature instanceof File) {
            URL.revokeObjectURL(e.target.src);
          }
        }}
      />
    ) : serverdriverSignature?(<> <img
        className="w-40 h-24 object-contain border border-gray-200 rounded-md bg-white"
        src={`https://hub2.ntactops.com/ntact/files/forms_files/${serverdriverSignature?.file_name}`}
        alt="Supervisor Signature"
        
      /></>): (
      <div className="w-40 h-24 flex items-center justify-center border border-gray-200 rounded-md bg-gray-100 text-gray-400 text-xs">
        No signature
      </div>
    )}
                  </div>
                </div>
                <div className="mt-6 bg-gray-100 border-gray-200 border-t overflow-hidden">
                  <span className="flex block font-inter bg-gray-100 p-3 text-gray-700">
                    <DescriptionIcon className="mr-2" /> {t("Document Information")}
                  </span>
                  <div className="flex w-full justify-center">
                    <div className="flex w-[95%] p-6 rounded-[10px] border mb-4 bg-[white] border-gray-200">
                      <div className="w-[50%]">
                        <p className="mb-2 my-0 text-gray-700 flex font-semibold">{t("Weekly Driver Log & safety")}</p>
                        <p className="font-inter text-xs text-gray-500 my-0 text-left">{t("Track weekly driving activities and safety compliance")}</p>
                      </div>
                      <div className="flex w-[50%] justify-around items-center">
                        <div className="">
                          <p className="font-inter my-0 text-left">{t("Form Details")}</p>
                          <p className="text-left text-sm text-gray-600 font-inter">
                          {t("Form") + " " + t("Type")}:<br />
                            <span className="text-gray-600 font-inter">{t("Submission")}:</span>
                          </p>
                        </div>
                        <div className="flex flex-col mt-6">
                          <p className="text-gray-700 flex text-sm font-semibold">{t("Weekly Driver Log")}</p>
                          <p className="text-left font-inter text-sm">{t("Weekly")}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="p-6 flex justify-between">
            {currentStep > 1 && (
              <button
                onClick={prevStep}
                className="bg-white border border-gray-300 text-black font-bold py-2 px-6 rounded hover:bg-gray-100"
              >
                ← {t("Previous")}
              </button>
            )}
            <button
              onClick={() => nextStep()}
              className="bg-[#DC2626] text-white font-semibold py-2 px-6 rounded hover:bg-red-600 ml-auto"
            >
             {currentStep === 4 ? t("Submit") : `${t("Next")} →`}

            </button>
          </div>
        </div>
      </div>
      <ToastMessage message={alertMessage} severity={severity} open={open} handleClose={handleCloseToast} />
  <SignatureModal isModal={signaturemodal} setModal={setSignatureModal} onSave={HandleSignature} />
  {dayOffConfirmModal.open && (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[10000] px-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md p-6">
        <h3 className="text-lg font-inter font-semibold text-gray-900 mb-2">
          {t("Day off confirmation")}
        </h3>
        <p className="text-sm font-inter text-gray-600">
          {t("You marked off on")}{" "}
          <span className="font-semibold text-gray-800">
            {dayOffConfirmModal.dayOffNames.map((d) => t(d)).join(', ')}
          </span>
          .{' '}
          {t("Are you sure you want to submit?")}
        </p>
        <div className="flex justify-end gap-2 mt-5">
          <button
            onClick={() => setDayOffConfirmModal({ open: false, dayOffNames: [] })}
            className="px-4 py-1.5 text-sm font-inter rounded-md border border-gray-200 hover:bg-gray-100 text-gray-700"
          >
            {t("Go Back")}
          </button>
          <button
            onClick={() => {
              setDayOffConfirmModal({ open: false, dayOffNames: [] });
              // `force=true` so the case-4 branch skips this same modal and
              // falls through to handleSubmit().
              nextStep(true);
            }}
            className="px-4 py-1.5 text-sm font-inter rounded-md bg-red-600 text-white hover:bg-red-700 font-medium"
          >
            {t("Yes, Submit")}
          </button>
        </div>
      </div>
    </div>
  )}
<Backdrop
  sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
  open={loader}
>
  <CircularProgress color="inherit" />
</Backdrop>
    </div>
  );
};

export default MultiStepForm;